import { ArrowSquareOut, CheckCircle, WarningCircle } from "@phosphor-icons/react";
import { formatCapeTownDateTime } from "@shared/lib/dates";
import type { DashboardResponse } from "@shared/schemas/domain";
import { SignalMark } from "@/components/SignalMark";
import { REPOSITORY_URL } from "@/lib/repository";

export function SourceFooter({ data }: { data: DashboardResponse }) {
  const enabled = data.sources.filter((source) => source.enabled);
  const healthy = enabled.filter((source) => source.status === "healthy").length;
  return (
    <footer className="source-footer">
      <div className="source-footer__line">
        <span className="source-footer__brand"><SignalMark /><strong>AI Signal</strong></span>
        <span>{healthy}/{enabled.length} sources healthy</span>
        <span>24h success {data.meta.sourceCoverage.successRate24h === null ? "pending" : `${data.meta.sourceCoverage.successRate24h}%`}</span>
        <span>7d success {data.meta.sourceCoverage.successRate7d === null ? "pending" : `${data.meta.sourceCoverage.successRate7d}%`}</span>
        <span>v{data.meta.version}</span>
        <span>No analytics · no account</span>
        {REPOSITORY_URL && <a className="external-link" href={REPOSITORY_URL} target="_blank" rel="noopener noreferrer">Repository <ArrowSquareOut aria-hidden="true" /></a>}
      </div>
      <details id="sources" className="source-details">
        <summary>Source health and methodology</summary>
        <div className="source-details__content">
          <div>
            <h3>Method in 30 seconds</h3>
            <p>Current coding rank uses one fresh SWE-rebench window. Provider-published benchmark tables are retained with their exact effort and harness, but never blended into the independent rank.</p>
            <p>Sources run in three bounded hourly shards, so each is attempted every three hours. Every attempt is retained for seven days; a later success does not erase reliability history.</p>
          </div>
          <ul className="source-list">
            {enabled.map((source) => (
              <li key={source.id} data-status={source.status}>
                {source.status === "healthy" ? <CheckCircle aria-hidden="true" weight="fill" /> : <WarningCircle aria-hidden="true" weight="fill" />}
                <span><a className="external-link" href={source.homepageUrl} target="_blank" rel="noopener noreferrer">{source.name} <ArrowSquareOut aria-hidden="true" /></a><small>{source.lastSuccessAt ? `Fetched ${formatCapeTownDateTime(source.lastSuccessAt)}` : "Awaiting first sync"} · 24h {source.successRate24h === null ? "pending" : `${source.successRate24h}%`} · 7d {source.successRate7d === null ? "pending" : `${source.successRate7d}%`}</small></span>
                <b>{source.status}</b>
              </li>
            ))}
          </ul>
        </div>
      </details>
    </footer>
  );
}
